import React from 'react';
import './HoldReasonsBadge.css';

// Reason codes era_auto_post_service records on remittances.hold_reasons. The
// two in CONFIRM_CODES are the ones where pressing Post can apply money twice;
// the backend answers 409 for them until the request says confirm=true.
export const CONFIRM_CODES = new Set(['duplicate_era', 'claim_already_paid']);

// Short badge text per code. The backend's one-line label is the tooltip.
const SHORT = {
  duplicate_era: 'Duplicate ERA',
  claim_already_paid: 'Already posted at this sequence',
  unmatched_claim: 'Unmatched claim',
  claim_repeated_on_era: 'Claim repeated',
  negative_or_reversed_claim: 'Reversed claim',
  nonpositive_total: 'Zero or negative total',
  plb_or_forwarding_balance: 'PLB / forwarding balance',
  claims_do_not_sum_to_check: 'Claims do not sum to check',
  line_paid_mismatch: 'Lines do not sum to claim',
  paid_exceeds_charge: 'Paid over charge',
  held_carc: 'Held code',
  payer_never_seen: 'New payer',
  no_claims: 'No claims',
  not_unposted: 'Not unposted',
};

export function shortLabel(reason) {
  const base = SHORT[reason.code] || reason.label || reason.code;
  // A held_carc reason names the codes that tripped the practice's hold list.
  if (reason.code === 'held_carc' && Array.isArray(reason.carcs) && reason.carcs.length) {
    return `${base} ${reason.carcs.join(', ')}`;
  }
  return base;
}

/**
 * "held:" and one badge per reason an ERA is waiting for a person. Nothing
 * rendered when there are no reasons (the migration not run yet reads as
 * none). A duplicate_era reason links to the other copy's id through onJump.
 */
export default function HoldReasonsBadge({ reasons, onJump }) {
  if (!Array.isArray(reasons) || reasons.length === 0) return null;
  return (
    <span className="hold-reasons" data-testid="hold-reasons">
      <span className="hold-reasons-prefix">held:</span>
      {reasons.map((r) => {
        const confirm = CONFIRM_CODES.has(r.code);
        const otherId = r.code === 'duplicate_era' ? r.other_remittance_id : null;
        return (
          <span
            key={r.code}
            className={`hold-badge ${confirm ? 'hold-badge--confirm' : 'hold-badge--info'}`}
            title={r.label || r.code}
            data-code={r.code}
          >
            {shortLabel(r)}
            {otherId ? (
              <>
                {' '}
                <button
                  type="button"
                  className="hold-badge-link"
                  title={`Open remittance #${otherId}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (onJump) onJump(otherId);
                  }}
                >
                  #{otherId}
                </button>
              </>
            ) : null}
          </span>
        );
      })}
    </span>
  );
}
